import { FC, ReactNode } from 'react';
import LabelRequiredSymbol from 'components/new-ui/base/label/LabelRequiredSymbol';
import { Space } from 'antd';

interface Props {
    label: string;
    htmlFor: string;
    required?: boolean;
    children: ReactNode;
}

const LabeledField: FC<Props> = ({ label, htmlFor, required, children }) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%' }}>
        <label htmlFor={htmlFor}>
            <Space size={8}>
                {label}
                {required && <LabelRequiredSymbol />}
            </Space>
        </label>
        {children}
    </div>
);

export default LabeledField;
